import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Paper,
  Modal,
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useFormik } from 'formik'
import { ValidationSchema } from './schema'
import { addUser, singleUser, updateUser } from '../../utils/templatesApi'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
}

const AddUserForm = ({ setRefresh, open, handleOpen, handleClose }) => {
  const [data, setData] = useState(null)
  const { id } = useParams()
  const navigate = useNavigate()
  const Options = [
    { value: 'admin', name: 'admin' },
    { value: 'user', name: 'user' },
  ]
  useEffect(() => {
    const fetchUser = async () => {
      if (id) {
        const response = await singleUser(id)
        setData(response?.data)
      } else {
        setData(null) 
      }
    }
    fetchUser()
  }, [id])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: data?.first_name || '',
      last_name: data?.last_name || '',
      role: data?.role || 'user',
      email: data?.email || '',
      password: '',
    },
    validationSchema: () => ValidationSchema(id),
    onSubmit: async (values, { resetForm }) => {
      if (id) {
        const response = await updateUser(id, values)
        if (response.success) {
          toast.success('User Updated Successfully')
          setRefresh(prev => !prev)
          navigate('/users')
          
          handleClose()
        } else {
          toast.error(response.message)
          navigate('/users')

        }
      } else {
        const response = await addUser(values)
        if (response.success) {
          resetForm()
          setRefresh(prev => !prev)
          handleClose()
          toast.success('User Added Successfully')
        } else {
          toast.error(response.message)
        }
      }
    },
  })

  return (
    <Container maxWidth='lg' sx={{ minWidth: '80vw' }}>
      <Button
        type='submit'
        variant='contained'
        sx={{
          textTransform: 'capitalize',
          height: '50px',
          width: '120px',
          fontSize: '16px',
          display: 'flex',
          justifySelf: 'end',
          mt: 4,
          backgroundColor: '#111827',
        }}
        onClick={handleOpen}
      >
        Create
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Paper elevation={3} sx={style}>
          <Typography variant='h3' align='center' fontWeight={550} gutterBottom>
            {id ? 'Edit' : 'Add'} User
          </Typography>
          <Box component='form' onSubmit={formik.handleSubmit} noValidate>
            <TextField
              fullWidth
              label='First Name'
              name='first_name'
              margin='normal'
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.first_name && Boolean(formik.errors.first_name)
              }
              helperText={formik.touched.first_name && formik.errors.first_name}
            />
            <TextField
              fullWidth
              label='Last Name'
              name='last_name'
              margin='normal'
              value={formik.values.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.last_name && Boolean(formik.errors.last_name)
              }
              helperText={formik.touched.last_name && formik.errors.last_name}
            />
            <FormControl fullWidth margin='normal'>
              <InputLabel id='role-label'>Role</InputLabel>
              <Select
                labelId='role-label'
                id='role'
                name='role'
                value={formik.values.role}
                label='Role'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.role && Boolean(formik.errors.role)}
              >
                {Options.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label='Email'
              name='email'
              type='email'
              margin='normal'
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              disabled={id ? true : false}
            />
            {id ? null : (
              <TextField
                fullWidth
                label='Password'
                name='password'
                type='password'
                margin='normal'
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
              />
            )}
            <Button type='submit' variant='contained' fullWidth sx={{ mt: 2 }}>
              {id ? 'Update User' : 'Add User'}
            </Button>
          </Box>
        </Paper>
      </Modal>
    </Container>
  )
}

export default AddUserForm
